import React from "react";
import "../../../About/AboutPages/Board_of_Mentor/Mentor.css";

const Stories = () => {
  return (
    <div className="mentor-container">
      <div className="mentor-card">
        <h1 className="mentor-title"> Stories</h1>
        <p className="mentor-subtitle">
          Real stories. Real impact.
        </p>

        <div className="coming-soon">
          📖 Stories Coming Soon
        </div>

        <p className="mentor-description">
          Discover inspiring stories from our outreach initiatives, featuring
          industry leaders, communities, and meaningful journeys.
        </p>
      </div>
    </div>
  );
};

export default Stories;
